<template>
  <div class="selector-grid__wrapper">
    <div class="selector-grid__item selector-grid__item--fabric"
         :class="selectedFabric && selectedFabric.name === item.name  ? 'selected' : ''"
         v-for="(item,i) in items" :key="item.id"
         @click="setFabric(item,i)">
      <div class="selector-grid__image-container selector-grid__image-container--fabric" :style="{backgroundImage: `url(${item.material.bumpMap.src || item.material.alphaMap.src})`}" alt=""></div>
      <h4 class="selector-grid__title selector-grid__title--fabric">{{ item.label }}</h4>
    </div>
  </div>
</template>

<script>

  import { mapActions, mapGetters, mapMutations } from 'vuex';
  import * as mutationTypes from '../../store/mutation-types'

  export default {
    name: "FabricGrid",
    props: {
      items: {
        type: Array,
        default: () => {
          return [];
        }
      }
    },
    data() {
      return {
        itemsPerSlide: 3,
        vilibleSlide: 3,
        selectedDress: null,
      }
    },
    computed: {
      ...mapGetters('fabrics',[
        'selectedFabric',
      ]),
      ...mapGetters('clothes',[
        'selectedMesh',
      ]),
      arrowsOutside: function() {
        return this.items.length > this.vilibleSlide;
      },
    },
    watch: {
      selectedMesh: function() {
        if(!this.selectedMesh || !this.selectedMesh.userData) return;

        if(this.selectedMesh.userData.fabric) {
          this[mutationTypes.APPLY_FABRIC](this.selectedMesh.userData.fabric);
          this.goToSlide(this.selectedMesh.userData.fabric);
        }
      }
    },
    methods: {
      ...mapActions('fabrics',[
        'applyFabric',
        'initFabric',
      ]),
      ...mapActions('textures',[
        'uploadTexture',
      ]),
      ...mapActions('clothes',[
        'disposeMesh',
      ]),
      ...mapActions([
        'render'
      ]),
      ...mapMutations('fabrics',[
        mutationTypes.APPLY_FABRIC,
      ]),
      async setFabric(fabric) {
        this.$Progress.start();
        await this.$store.dispatch('fabrics/applyFabric',{ payload: fabric});
        this.$Progress.finish();
      },
      goToSlide(fabric) {
        let i = this.items.indexOf(fabric);
        this.$refs.slider && this.$refs.slider.goToSlide(i);
      }
    },
    mounted() {
      // console.log(this.items);
      this.vilibleSlide = this.items.length > this.itemsPerSlide ? this.itemsPerSlide : this.items.length;
      // console.log(this.selectedMesh);
      if(this.selectedMesh && this.selectedMesh.userData.fabric) {
        this[mutationTypes.APPLY_FABRIC](this.selectedMesh.userData.fabric);
        this.goToSlide(this.selectedMesh.userData.fabric);
      }
    }
  }
</script>

<style scoped>

  .selector-grid__item--fabric {
    width: 45%;
  }

  .selector-grid__image-container--fabric {
    padding-top: 61%;
  }

</style>